module.exports = __webpack_public_path__ + "static/img/sxbg.8d68b98b.png";